import {tokenAndRoute} from "../utils/tokenAndRoute";
import {loaderMixin} from "../utils/loaderMixin";
import thingOne from "../../components/Pages/Things/Things/thingOne";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {filters} from "../filters";

export const getThingsFromTree = {
  mixins: [tokenAndRoute, loaderMixin, filters],
  components: {
    thingOne
  },
  data() {
    return {
      allDevices: []
    }
  },
  computed: {
    ...mapState({
      projects: state => state.projects.allProjects
    }),
    ...mapGetters({
    }),
  },
  watch: {
    routeId()  {
      this.getThings()
    },
    routeItem()  {
      this.getThings()
    },
    projects() {
      this.getThings()
    }
  },
  methods: {
    ...mapMutations({
      setDirName: 'things/SET_DIR_NAME'
    }),
    getThings() {
      let allDevices = [];
      let project;
      let projectItem;
      let getDevices = (arr) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].devices.length > 0) {
            for (let j = 0; j < arr[i].devices.length; j++) {
              allDevices.push(arr[i].devices[j])
            }
          }
          if (arr[i].items.length > 0) {
            getDevices(arr[i].items)
          }
        }
      }

      let getProjectItem = (arr) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id === Number(this.routeItem)) {
            projectItem = arr[i]
            allDevices = projectItem.devices
            break;
          }
          if (arr[i].items && arr[i].items.length > 0) {
            getProjectItem(arr[i].items)
          }
        }
      }

      if (this.routeItem) {
        project = this.projects.find(project => project.id === Number(this.routeId))
        if (project) {
          getProjectItem(project.items)
        }
      } else if (this.routeId)  {
        project = this.projects.find(project => project.id === Number(this.routeId))
        if (project) {
          if (project.devices) {
            for (let j = 0; j < project.devices.length; j++) {
              allDevices.push(project.devices[j])
            }
          }
          getDevices(project.items)
        }
      }

      if (projectItem) {
        this.setDirName(projectItem.name)
      } else if (project) {
        this.setDirName(project.name)
      }

      this.allDevices = this.delDouble(allDevices, 'id')
    }
  },
  mounted() {
    this.allDevices = ''
    this.getThings()
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.showLoader();
      vm.hideLoader();

      vm.allDevices = ''
      vm.getThings()
    })
  }
}
